let mutations = {
    setAllAnswer(state, data) {
        state.lAnswers = data;
    },
    setlAnswerModel(state, data) {
        let index = data.index;
        state.lAnswers[index] = data;
    },
    clearLAnswer(state) {
        state.lAnswers = [];
    }
}
export default mutations;


// WEBPACK FOOTER //
// ./src/vuex/modules/lAnswerModel/mutations.js